const CourseList = [
    {
        image: require('../../assets/images/course/1.png'),
        category: "Angular",
        title: "Learn Angular Fundamentals",
        description: "Learn how to build and launch React web applications using .."
    },
    {
        image: require('../../assets/images/course/2.png'),
        category: "HTML",
        title: "Learn HTML Fundamentals",
        description: "Learn how to build and launch React web applications using .."
    },
    {
        image: require('../../assets/images/course/3.png'),
        category: "CSS",
        title: "Learn CSS Fundamentals",
        description: "Learn how to build and launch React web applications using .."
    }

];

export default CourseList;